import getHelper from '../../../services/getHelper';

export default getHelper('/student-credentials-parchment-informations/:id');
